import * as React from 'react';
import { useMemo } from 'react';
import { makeRequestSelector, useAppSelector } from '@wappsto/redux';
import GenericNotification from './GenericNotification';
import SharePermission from './SharePermission';
import InstallationPermission from './InstallationPermission';
import InstallationPrecisePermission from './installationPrecisePermission';
// import Background from './Background';
import InstallationMessage from './InstallationMessage';

const READ = 'read';

interface NotificationsItemProps {
  notification: any;
  deleteNotification: (...args: any[]) => any;
  setDropdownVisible: (...args: any[]) => any;
  updateNotificationStatus: (...args: any[]) => any;
}

const NOTIFICATIONS: Record<number, React.ComponentType<any>> = {
  1100011: InstallationMessage,
  // 1100028: Background,
  1100002: InstallationPrecisePermission,
  1100003: InstallationPermission,
  1100004: SharePermission,
};

const NotificationsItem = React.memo(
  ({ notification, deleteNotification, setDropdownVisible, updateNotificationStatus }: NotificationsItemProps) => {
    const getRequest = useMemo(makeRequestSelector, []);
    const deleteRequest = useAppSelector(state =>
      getRequest(state, `delete_notification_${notification.meta?.id}`),
    );

    if (notification.base === undefined || notification.meta === undefined) {
      return null;
    }

    const Notification = NOTIFICATIONS[notification.base.code] || GenericNotification;
    const isDeleting = deleteRequest?.status === 'pending' || false;

    const onClick = () => {
      updateNotificationStatus(notification, READ);
    };

    return (
      <Notification
        notification={notification}
        updateNotificationStatus={updateNotificationStatus}
        deleteNotification={deleteNotification}
        setDropdownVisible={setDropdownVisible}
        isDeleting={isDeleting}
        onClick={onClick}
      />
    );
  },
);

NotificationsItem.displayName = 'NotificationsItem';

export default NotificationsItem;
